import { Link } from 'react-router-dom';
import type { Article } from '@/types';
import { categories } from '@/mocks/categories';
import { fmtNum, tagClass } from '@/utils/helpers';

export default function ArticleCard({
  article,
  imageClass = 'h-44 md:h-52',
}: {
  article: Article;
  imageClass?: string;
}) {
  const cat = categories.find((c) => c.slug === article.cat);
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg bg-background-50 border border-background-200 transition duration-300 hover:-translate-y-1">
      <Link
        to={`/post/${article.id}`}
        className={`relative block overflow-hidden ${imageClass}`}
        aria-label={`阅读：${article.title}`}
      >
        <img
          src={article.cover}
          alt={article.alt}
          title={`${article.title} - 每日大瓜吃瓜时间线`}
          className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
        />
        {article.hotReversal && (
          <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-semibold text-background-50">
            <i className="ri-flashlight-fill" aria-hidden="true" /> 连环反转
          </span>
        )}
        <span className="absolute bottom-3 left-3 rounded-full bg-background-950/70 px-2.5 py-1 text-xs font-medium text-background-100 backdrop-blur">
          {cat?.name}
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <span className={`mb-2 inline-flex w-fit items-center rounded-md border px-2 py-0.5 text-xs font-medium ${tagClass(article.tag)}`}>
          <i className="ri-price-tag-3-line mr-1 text-xs" aria-hidden="true" />
          {article.tag}
        </span>
        <h3 className="mb-2 line-clamp-2 text-base md:text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
          <Link to={`/post/${article.id}`}>{article.title}</Link>
        </h3>
        <p className="mb-3 line-clamp-2 text-sm leading-relaxed text-foreground-600">{article.summary}</p>
        <div className="mt-auto flex items-center justify-between text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1 whitespace-nowrap">
            <i className="ri-time-line" aria-hidden="true" />
            {article.date}
          </span>
          <span className="inline-flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line" aria-hidden="true" />
            {fmtNum(article.reads)}热度
            <i className="ri-chat-3-line ml-2" aria-hidden="true" />
            {fmtNum(article.comments)}
          </span>
        </div>
      </div>
    </article>
  );
}